import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Starts each route at the top.
 *
 * A single-page application keeps the scroll position across a navigation, so
 * following a link from halfway down one page lands halfway down the next. The
 * browser does this correctly for a full page load; a client-side router has to
 * be told.
 *
 * Keyed on pathname alone, so a change of query string or hash does not yank
 * the reader back to the top of a page they are already reading.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
  }, [pathname])

  return null
}
